import * as _ from "lodash";
import { createSelector } from "reselect";
import { LeadChannel, LeadReason } from "office/reports/leads/LeadsReport";
import EnumHelper from "common/utils/EnumHelper";
import DateHelper from "common/utils/DateHelper";
//-- Selector
const mapLeadItems = (items) => {
    let newList = [];
    if (items) {
        items.map((item) => {
            item.dateTime = `${DateHelper.parseDateToString(item.date)} ${DateHelper.parseTimeToString(item.timeStamp)}`;
            item.channel = EnumHelper.GetDescription(LeadChannel, item.channel);
            item.reason = EnumHelper.GetDescription(LeadReason, item.reason);
            delete item.date;
            delete item.timeStamp;
            newList.push(item);
        });
    }
    return newList;
};
const stateReportSelector = (state) => state.reports.officeReports.leads;
export const reportSelector = createSelector(stateReportSelector, (report) => {
    if (!report) {
        return {
            isFetching: true,
            reportData: null
        };
    }
    let reportClone = _.cloneDeep(report);
    return {
        isFetching: report.isFetching,
        //            reportKey: uuid.v4(),
        reportData: {
            officeId: reportClone.officeId,
            officeName: reportClone.officeName,
            startDate: reportClone.startDate,
            endDate: reportClone.endDate,
            items: mapLeadItems(reportClone.items)
        }
    };
});
export default reportSelector;
